import { render } from "./ShopPage.vue?vue&type=template&id=37c9f982"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__